module.exports = __webpack_public_path__ + "static/media/iifl_finance.649e0221.svg";